import react from "react";
import { Helmet } from "react-helmet";
import { Link, NavLink } from "react-router-dom";

import DogBowie from "../../dogs/dog_bowie";  
import DogGoose from "../../dogs/dog_goose";

function LitterBowieGoose01() {
  return (


    <div >
      <Helmet>
       <title>Litters - Bowie and Charlie 2022 - High Altitude Labrador Retrievers</title>
       <link rel="canonical" href="https://highaltitudelabs.com/litters/previous/bowie_goose_2025" />
     </Helmet>

     <section className="littercontainer">
        <div><h6 className="main-blue">Bowie and Goose 2025</h6><hr></hr></div>
          <div className="row">
            <div className="col s12">
            <br></br>
            <h6>Puppies Whelped 2025-07-06! Ready to go Home 2025-08-31.</h6>
            <div className="bulletList">
              
              <ul>
                <li>
                  <NavLink to="/litters/previous/bowie_goose_2025/puppies">Puppy Pictures</NavLink>
                </li>
              </ul>
            </div>
          <div><h6 className="main-blue">Dam</h6><hr></hr></div>
          <DogBowie />
          <div><h6 className="main-blue">Sire</h6><hr></hr></div>
          <DogGoose />
            </div>
          </div>
        </section>
    </div>


  );
}

export default LitterBowieGoose01
